import { multiSelectFilter, createActionsColumn, urlCell, longTextCell } from '../columnUtils';

export const createIcd10ToI8000Columns = (setSelectedItem, setDrawerVisible, handleDelete) => [
  {
    id: 'icd10Undotted',
    header: 'ICD10 Undotted',
    accessorKey: 'icd10Undotted',
    enableSorting: true,
    sortingFn: 'text',
    filterFn: multiSelectFilter
  },
  {
    id: 'icd10',
    header: 'ICD10',
    accessorKey: 'icd10',
    enableSorting: true,
    sortingFn: 'text',
    filterFn: multiSelectFilter
  },
  {
    id: 'shortDescription',
    header: 'Short Description',
    accessorKey: 'shortDescription',
    enableSorting: true,
    sortingFn: 'text',
    filterFn: multiSelectFilter
  },
  {
    id: 'longDescription',
    header: 'Long Description',
    accessorKey: 'longDescription',
    size: 220,
    enableSorting: false,
    filterFn: multiSelectFilter,
    cell: longTextCell
  },
  {
    id: 'comorbidityDisplayName',
    header: 'Comorbidity Display Name',
    accessorKey: 'comorbidityDisplayName',
    enableSorting: true,
    sortingFn: 'text',
    filterFn: multiSelectFilter
  },
  {
    id: 'points',
    header: 'Points',
    accessorKey: 'points',
    enableSorting: true,
    sortingFn: 'alphanumeric',
    filterFn: multiSelectFilter
  },
  {
    id: 'sourceUrlPoints',
    header: 'Source URL (Points)',
    accessorKey: 'sourceUrlPoints',
    enableSorting: false,
    enableColumnFilter: false,
    cell: urlCell
  },
  {
    id: 'sourceUrlMapping',
    header: 'Source URL (Mapping)',
    accessorKey: 'sourceUrlMapping',
    enableSorting: false,
    enableColumnFilter: false,
    cell: urlCell
  },
  createActionsColumn(setSelectedItem, setDrawerVisible, handleDelete)
];
